import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
import "firebase/compat/functions";
// import { getAnalytics } from "firebase/analytics";
import { firebaseConfig } from "./config";

const app = firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();
const database = firebase.database();
const functions = firebase.app().functions("us-central1");
const auth = firebase.auth;
// const analytics = getAnalytics(app);

// TODO: Make this react to the presence/absence of the emulator in dev.
// if (IS_DEVELOPMENT) {
//   try {
//     connectFunctionsEmulator(functions, 'localhost', 5001);
//   } catch (error) {
//     console.error('Error connecting to functions emulator', error);
//   }
// }

export { app, firestore, database, auth, functions };
